<template>
  <section class="page-hd">
    <div class="sponsor">
      <div class="sponsor-img"></div>
    </div>
    <div class="act">
      <div class="act-img"></div>
      <div class="act-desc">
        <p v-if="titleL1" class="act-desc_p1 tips">{{titleL1}}</p>
        <p v-if="titleL2" class="act-desc_p2 tips">{{titleL2}}</p>
      </div>
      <div class="act-time">
        <div v-if="dateL1" class="act-time_title tips">{{dateL1}}</div>
        <div v-if="dateL2" class="act-time_desc tips">{{dateL2}}</div>
      </div>
    </div>
  </section>
</template>
<script>
    export default {
        name: 'HelloWorld',
        props: {
            titleL1: String,
            titleL2: String,
            dateL1: String,
            dateL2: String
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>